import { useMemo } from 'react';

import column, { defaultColumnId } from '@Components/Grid/utils/column';

import { useContestsStore } from '../../../store';

import DatetimeFormatter from './DatetimeFormatter';
import EntriesFormatter from './EntriesFormatter';
import FrequencyFormatter from './FrequencyFormatter';
import RegistrationModeFormatter from './RegistrationModeFormatter';
import SCAStatusFormatter from './SCAStatusFormatter';
import StatusFormatter from './StatusFormatter';
import SweepFormatter from './SweepFormatter';
import WinnerCountFormatter from './WinnerCountFormatter';

export default function useColumns() {
  const { lists: { 'cms/posts': { items: sweeps } } } = useContestsStore()

  return useMemo(() => [
    defaultColumnId(),
    column.accessor('sweepId', {
      header: 'Sweep',
      cell: info => <SweepFormatter info={info} sweeps={sweeps} />,
    }),
    column.accessor('active', {
      header: 'Status',
      cell: info => <StatusFormatter info={info} />,
      enableColumnResize: false,
    }),
    column.accessor('sweepsContestWinners', {
      header: 'SCA',
      cell: info => <SCAStatusFormatter info={info} />,
      enableColumnResize: false,
    }),
    column.accessor('startsAt', {
      header: 'Starts At',
      cell: info => <DatetimeFormatter info={info} />,
      enableTruncate: true,
    }),
    column.accessor('endsAt', {
      header: 'Ends At',
      cell: info => <DatetimeFormatter info={info} />,
      enableTruncate: true,
    }),
    column.accessor('winnerFrequency', {
      header: 'Frequency',
      cell: info => <FrequencyFormatter info={info} />,
    }),
    column.accessor('regMode', {
      header: 'Registration Mode',
      cell: info => <RegistrationModeFormatter info={info} />,
    }),
    column.accessor('optins', {
      header: 'Entries',
      cell: info => <EntriesFormatter info={info} />,
      size: 100,
    }),
    column.accessor('confirmedOptins', {
      header: 'Confirmed Entries',
      cell: info => <EntriesFormatter info={info} confirmed />,
      size: 100,
    }),
    column.accessor('sweepsContestWinners', {
      header: 'Winner Count',
      cell: info => <WinnerCountFormatter info={info} />,
      enableSorting: false,
      size: 100,
    }),
  ], [sweeps])
}
